import { GetterTree } from "vuex";
import { IReportFileState } from "@/store/modules/reportFile/state";
import { IReportFile } from "@/store/modules/reportFile/state";
import { IDataProvider, IRootState } from "@/store";

export enum ReportFileGetters {
  GET_ALL = "GET_ALL_REPORT_FILE",
  GET_CURRENT = "GET_CURRENT_REPORT_FILE",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_REPORT_FILE",
}

export const getters: GetterTree<IReportFileState, IRootState> = {
  [ReportFileGetters.GET_ALL](state): IReportFile[] | null {
    return state.reportFiles;
  },
  [ReportFileGetters.GET_CURRENT](state): IReportFile | null {
    return state.reportFile;
  },
  [ReportFileGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<IReportFile> | null {
    return state.dataProvider;
  },
};
